import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { LanguageProvider } from "@/context/LanguageContext";
import { AuthProvider } from "@/context/AuthContext";
import { IntradaySizingProvider } from "@/context/IntradaySizingContext";
import { StrategyVariantProvider } from "@/context/StrategyVariantContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <LanguageProvider>
    <AuthProvider>
    <StrategyVariantProvider>
    <IntradaySizingProvider>
      <App />
    </IntradaySizingProvider>
    </StrategyVariantProvider>
    </AuthProvider>
  </LanguageProvider>,
);
